export default __webpack_public_path__ + "static/media/csulok_pekne_modra.73eecc23.jpg";